export default "__VITE_ASSET__CoeTU5Di__"